import React, { useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import { categories, type Calculator } from '../../utils/calculators';
import SEO from './SEO';

export default function DynamicSEO() {
  const location = useLocation();
  const path = location.pathname;

  const { metaData, isCalculator, isCategory, calc } = useMemo(() => {
    // 1. Check if it's a category page
    const category = categories.find(c => c.path === path);
    if (category) {
      return { 
        metaData: { title: `${category.name} | StockMarketor`, description: category.description },
        isCategory: true,
        isCalculator: false
      };
    }

    // 2. Check if it's an individual calculator page
    let foundCalc: Calculator | undefined;
    for (const cat of categories) {
      const calc = cat.calculators.find(c => c.path === path);
      if (calc) {
        foundCalc = calc;
        break;
      }
    }

    if (foundCalc) {
      return {
        metaData: { title: `${foundCalc.name} | StockMarketor`, description: foundCalc.description },
        isCategory: false,
        isCalculator: true,
        calc: foundCalc
      };
    }

    return { metaData: null, isCategory: false, isCalculator: false };
  }, [path]);

  // If no dynamic metadata found (e.g. for Home, About, which have static SEO), render nothing here.
  if (!metaData) return null;

  // Generate structured data for individual calculators
  let structuredData;
  if (isCalculator && calc) {
    structuredData = {
      "@context": "https://schema.org",
      "@type": "SoftwareApplication",
      "name": calc.name,
      "description": calc.description,
      "applicationCategory": "BusinessApplication",
      "operatingSystem": "Web",
      "offers": {
        "@type": "Offer",
        "price": "0",
        "priceCurrency": "USD"
      }
    };
  }

  return (
    <SEO 
      title={metaData.title}
      description={metaData.description}
      canonicalUrl={path}
      structuredData={structuredData}
    />
  );
}
